<div class="settings-page-container">
  <div class="container p-4">
    <div class="row">
      <div class="col-md-4">
        <div class="menu d-flex flex-column rounded border mb-5">
          <button
            *ngFor="let menuPoint of menuPoints"
            mat-button
            (click)="openMenuPoint(menuPoint.id)"
            class="menuButton"
            [ngClass]="menuPoint.id === selectedPoint ? 'selected' : ''"
          >
            <mat-icon
              matBadge="&#8288;"
              [matBadgeHidden]="!menuPoint.hasChanges"
              matBadgeColor="accent"
              [matBadgeOverlap]="true"
              matBadgePosition="before"
              matBadgeSize="small"
              >{{ menuPoint.icon }}</mat-icon
            >
            <span>{{ menuPoint.name }}</span>
          </button>
        </div>
      </div>
      <div [ngSwitch]="selectedPoint" class="col-md-8">
        <h1 class="mat-h1 mb-2" i18n>Settings</h1>
        <mat-divider class="mb-3"></mat-divider>
        <div [hidden]="selectedPoint !== 'profile'">
          <!-- Basic profile properties -->
          <h2 class="mat-h2" i18n>Public profile</h2>
          <span class="mat-body" i18n>
            You can edit your public profile here. The information on your
            public profile can be seen by everyone, even unauthenticated
            visitors.
          </span>

          <app-edit-profile
            #editProfileComponent
            class="mt-4"
            (changes)="profileHasChanges($event)"
          ></app-edit-profile>
        </div>
        <div *ngSwitchCase="'login'">
          <h2 class="mat-h2" i18n>Login information</h2>
          <p class="mat-body" i18n>
            Your login information. Your E-mail address here is used for your
            login. You can add the same E-mail address or a different one to
            your contact information.
          </p>
          <div class="my-4">
            <h3 class="mat-h3" i18n>E-Mail address</h3>
            <div class="d-flex flex-column my-4">
              <mat-form-field appearance="outline">
                <mat-label i18n>E-mail address</mat-label>
                <input
                  #emailInput
                  matInput
                  type="text"
                  [value]="emailAddress"
                  (keyup)="emailAddress = emailInput.value"
                />
                <mat-icon
                  *ngIf="!authService.user?.emailVerified"
                  matSuffix
                  i18n-matTooltip
                  matTooltip="Your E-mail has not been verified!"
                  >warning</mat-icon
                >
                <mat-icon
                  *ngIf="authService.user?.emailVerified"
                  matSuffix
                  i18n-matTooltip
                  matTooltip="Your E-mail is verified"
                  >verified</mat-icon
                >
                <mat-hint i18n
                  >Changing this E-mail will change your login
                  information</mat-hint
                >
              </mat-form-field>
              <button
                [disabled]="emailAddress === authService.user.email"
                mat-flat-button
                class="mt-3 mb-1"
                color="primary"
                (click)="changeEmailAddress()"
                i18n
              >
                Change E-mail address
              </button>
              <button
                *ngIf="!authService.user?.emailVerified"
                mat-flat-button
                class="mt-3 mb-1"
                color="accent"
                (click)="verifyUserEmailAddress()"
                i18n
              >
                Resend verification E-mail
              </button>
            </div>
            <div class="my-4">
              <h3 class="mat-h3" i18n>Password</h3>
              <div class="my-3 d-flex flex-column">
                <button mat-stroked-button class="mb-1" color="primary" i18n>
                  Change password
                </button>
              </div>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'general'">
          <h2 class="mat-h2" i18n>General settings</h2>
          <h3 class="mat-body" i18n>
            General settings to tune your experience on PK Spot.
          </h3>
          <!-- <div class="my-4">
            <h3 class="mat-h3">Geo-URI links</h3>
            <p class="mat-body">
              On supported mobile devices this will open the spot location in
              the preferred native maps app. This is enabled by default for the
              best experience.
            </p>
            <mat-checkbox [checked]="authService?.user?.settings?.useGeoURI !== false"
              >Use Geo-URI to open maps on mobile devices</mat-checkbox
            >
          </div>
          <div class="my-4">
            <h3 class="mat-h3">Preferred external maps application</h3>
            <p class="mat-body">
              This selection will be used if Geo-URI is not supported or
              disabled above.
            </p>
            <mat-button-toggle-group name="fontStyle" [value]="authService?.user?.settings?.maps || 'googlemaps'">
              <mat-button-toggle value="googlemaps"
                >Google Maps</mat-button-toggle
              >
              <mat-button-toggle value="applemaps"
                >Apple Maps</mat-button-toggle
              >
              <mat-button-toggle value="openstreetmap"
                >OpenSreetMap</mat-button-toggle
              >
            </mat-button-toggle-group>
          </div> -->
        </div>
        <div *ngSwitchCase="'notifications'">
          <h2 class="mat-h2" i18n>Notifications</h2>
        </div>
      </div>
    </div>
  </div>
</div>
<app-speed-dial-fab
  *ngIf="hasChanges"
  #saveSpeedDial
  id="saveSpeedDial"
  [buttonConfig]="speedDialButtonConfig"
  [openOnHover]="true"
  [rotationDegrees]="0"
  (mainFabClick)="saveAllChanges()"
  (miniFabClick)="miniFabPressed()"
></app-speed-dial-fab>
